/**
 * Markdown de Cultura: ESPEJO EXACTO de la app (mixcore-mobile/culture.js) y de
 * la web (MNW-User/src/screen/Comunidad/cultureContent.js), para que la vista
 * previa muestre lo mismo que verá la gente. Bloques: # y ## títulos,
 * párrafos, > citas y listas con - o *. En línea: **negrita**, *cursiva* o
 * _cursiva_ y [texto](https://…). Las imágenes se descartan; lo demás queda
 * como texto (nunca HTML).
 */

export type Span = { text: string; bold?: boolean; italic?: boolean; href?: string };
export type Block =
  | { type: "h1" | "h2" | "p" | "quote"; spans: Span[] }
  | { type: "list"; items: Span[][] };

const IMAGE = /^!\[[^\]]*\]\([^)]*\)$/;
const INLINE = /(!\[[^\]]*\]\([^)]*\)|\*\*[^*]+\*\*|\[[^\]]+\]\(https?:\/\/[^)\s]+\)|\*[^*\s][^*]*\*|_[^_\s][^_]*_)/g;

export function parseInline(text: string): Span[] {
  const out: Span[] = [];
  String(text || "")
    .split(INLINE)
    .forEach((part) => {
      if (!part || IMAGE.test(part)) return;
      if (part.startsWith("**") && part.endsWith("**") && part.length > 4) out.push({ text: part.slice(2, -2), bold: true });
      else if (/^\[[^\]]+\]\(https?:\/\/[^)\s]+\)$/.test(part)) {
        const m = part.match(/^\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)$/);
        if (m) out.push({ text: m[1], href: m[2] });
      } else if ((part.startsWith("*") && part.endsWith("*")) || (part.startsWith("_") && part.endsWith("_"))) {
        if (part.length > 2) out.push({ text: part.slice(1, -1), italic: true });
        else out.push({ text: part });
      } else out.push({ text: part });
    });
  return out;
}

export function parseMarkdown(md: string): Block[] {
  const blocks: Block[] = [];
  String(md || "")
    .replace(/\r\n/g, "\n")
    .split(/\n{2,}/)
    .forEach((chunk) => {
      const t = chunk.trim();
      if (!t) return;
      if (t.startsWith("## ")) {
        blocks.push({ type: "h2", spans: parseInline(t.slice(3).trim()) });
        return;
      }
      if (t.startsWith("# ")) {
        blocks.push({ type: "h1", spans: parseInline(t.slice(2).trim()) });
        return;
      }
      const lines = t.split("\n");
      if (lines.every((l) => /^\s*[-*]\s+/.test(l))) {
        blocks.push({ type: "list", items: lines.map((l) => parseInline(l.replace(/^\s*[-*]\s+/, ""))) });
        return;
      }
      if (lines.every((l) => /^\s*>/.test(l))) {
        blocks.push({ type: "quote", spans: parseInline(lines.map((l) => l.replace(/^\s*>\s?/, "")).join(" ")) });
        return;
      }
      blocks.push({ type: "p", spans: parseInline(lines.join("\n")) });
    });
  return blocks;
}
